module.exports = __webpack_public_path__ + "static/media/ic_instagram.fdad9b20.svg";